import axios from 'axios';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MOBIZ_API_URL, VERIFY_EMAIL, VERIFY_SOCIALID_URL } from '../../../constants/paths/api';
import { clientIdConfig } from '../../../helpers/mobizHelpers/configurations';
import IPageViewModel from '../../../interfaces/umbracoNodes/pageViewModel';
import { Columns } from '../../base/grid';
import { H1, P } from '../../base/typography';
import { RawLoader } from '../../loading/loading';
import * as StyledLandingPages from './landingPages.styles';
import LandingPagesResetPassword from './landingPagesResetPassword';
import LandingPagesVerifySocialId from './landingPagesVerifySocialId';

export interface LandingPageParameters {
	token: string;
	verificationid: string;
	email?: string;
}
interface Props {
	page: IPageViewModel;
	parameters: LandingPageParameters;
	landingPage: 'VERIFY_EMAIL' | 'VERIFY_SOCIALID' | 'RESET_PASSWORD';
}

const LandingPages: FC<Props> = ({ page, parameters, landingPage }) => {
	const { t } = useTranslation('myShipments');
	const [submitted, setSubmitted] = useState(false);
	const [submitSuccess, setSubmitSuccess] = useState(false);
	const [errorMessageResponse, setErrorMessageResponse] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [[header, paragraph], setHeaderAndParagraph] = useState(['', '']);

	const submitSocialId = (value: string) => {
		setLoading(true);
		const body = {
			token: parameters.token,
			email: value,
		};
		axios
			.post(`${MOBIZ_API_URL}${VERIFY_SOCIALID_URL}${parameters.verificationid}`, body, clientIdConfig)
			.then(() => {
				setSubmitted(true);
				setLoading(false);
				setSubmitSuccess(true);
				setHeaderAndParagraph([t(`${landingPage}.success-header`), t(`${landingPage}.success-paragraph`)]);
			})
			.catch(err => {
				setSubmitted(true);
				setLoading(false);
				setSubmitSuccess(false);
				setError(true);
				setErrorMessageResponse(err.response.data.details);
			});
	};

	// const submitResetPassword = (password: string, email: string) => {
	// 	setLoading(true);
	// 	console.log('submitresetPassword');
	// 	const body = {
	// 		code: parameters.token,
	// 		email: email,
	// 		confirmPassword: password,
	// 		password: password,
	// 	};
	// 	axios
	// 		.post(`${MOBIZ_API_URL}${RESET_PASSWORD_URL}`, body)
	// 		.then(() => {
	// 			setLoading(false);
	// 			console.log('success');
	// 			setSubmitSuccess(true);
	// 			setHeaderAndParagraph([t(`${landingPage}.success-header`), t(`${landingPage}.success-paragraph`)]);
	// 		})
	// 		.catch(err => {
	// 			console.log('failed', err);
	// 			setLoading(false);
	// 			setSubmitSuccess(false);
	// 			setError([true, 'RESET_PASSWORD.error-paragraph']);
	// 		});
	// };

	useEffect(() => {
		const submitVerifyEmail = () => {
			setLoading(true);
			axios
				.get(
					`${MOBIZ_API_URL}${VERIFY_EMAIL}${parameters.verificationid}?token=${parameters.token}`,
					clientIdConfig
				)
				.then(() => {
					setLoading(false);
					setSubmitSuccess(true);
					setHeaderAndParagraph([t(`${landingPage}.success-header`), t(`${landingPage}.success-paragraph`)]);
				})
				.catch(err => {
					setLoading(false);
					setSubmitted(true);
					setSubmitSuccess(false);
					setError(true);
					setErrorMessageResponse(
						err.response.data.details ? err.response.data.details : t('genericVerificationError')
					);
				});
		};

		if (landingPage === 'VERIFY_EMAIL') {
			submitVerifyEmail();
		}
	}, [setLoading, t, landingPage, parameters]);

	return (
		<StyledLandingPages.Wrapper>
			<Columns>
				<StyledLandingPages.FormWrapper>
					{submitSuccess ? (
						<>
							<H1>{header}</H1>
							<P>{paragraph}</P>
						</>
					) : null}
					{!submitSuccess && landingPage === 'VERIFY_SOCIALID' ? (
						<LandingPagesVerifySocialId
							submit={submitSocialId}
							landingPage={landingPage}
							error={error}
							errorMessage={errorMessageResponse}
						/>
					) : null}
					{!submitSuccess && landingPage === 'RESET_PASSWORD' ? (
						<LandingPagesResetPassword
							token={parameters.token}
							landingPage={landingPage}
							error={error}
							errorMessage={errorMessageResponse}
						/>
					) : null}
					{loading ? <RawLoader /> : null}
					{submitted && !submitSuccess && landingPage === 'VERIFY_EMAIL' ? (
						<>
							<H1>{t('status.Error')}</H1>
							<P>{t(errorMessageResponse)}</P>
						</>
					) : null}
					{/* {error ? (
						<>
							<H1>{t('status.Error')}</H1>
							<P>{t(errorMessage)}</P>
						</>
					) : null} */}
				</StyledLandingPages.FormWrapper>
				<StyledLandingPages.ImageWrapper>
					<StyledLandingPages.Image image={page.Values.PagePicture.Src} />
				</StyledLandingPages.ImageWrapper>
			</Columns>
		</StyledLandingPages.Wrapper>
	);
};

export default LandingPages;
